import React, { useState } from "react";
import { useEffect } from "react";
import { Link } from "react-router-dom";
import http from "../../../http";
import Swal from "sweetalert2";
import MaterialTableFixed from "../../../Components/MaterialTableFixed";
import "../../../imageUrl";
import { brandLang } from "../../../Components/language/pages/brandLang";
import useLanguage from "../../../Components/language/useLanguage";

function Brand() {
  const lan = useLanguage(brandLang);
  const [countrylist, setCountryList] = useState([]);

  useEffect(() => {
    http.get(`/brand`).then((res) => {
      console.log(res.data.data);
      if (res.status === 200) {
        setCountryList(res.data.data);
      }
    });
  }, []);

  const deleteCountry = (e, id) => {
    e.preventDefault();
    const thisClicked = e.currentTarget;

    Swal.fire({
      title: lan?.deleteConfirm,
      text: lan?.deleteText,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: lan?.yes,
    }).then((result) => {
      if (result.isConfirmed) {
        http.delete(`/brand/${id}`).then((res) => {
          if (res.data.status === 200) {
            thisClicked.closest("tr").remove();
          }
        });
        Swal.fire({
          position: "top-center",
          icon: "success",
          title: lan?.deleted,
          text: lan?.message,
          timer: 2500,
        });
      }
    });
  };

  const columns = [
   
    {
  title: "Brand Logo",  // header ঠিক থাকবে
  field: "photo",
  render: (row) => (
    <div className="text-center">
      {row.photo ? (
        <img
          src={`${global.img_url}/files/brand/${row.photo}`}
          width="40px"
          alt="Logo"
        />
      ) : (
        <img
          src={`${global.img_url}/files/no_images.png`}
          width="40px"
          alt="No Logo"
        />
      )}
    </div>
  ),
},

    {
      title: lan?.title,
      field: `title`,
      cellStyle: {
        textAlign: "center",
      },
    },
    // {
    //     title: "Slug", field: `slug`,
    //     cellStyle: {
    //         textAlign: "center",
    //     },

    // },

    {
      title: lan?.photo,
      field: `photo`,
      render: (row) => (
        <div className="text-center">
          {row.photo ? (
            <img
              src={`${global.img_url}/files/brand/${row.photo}`}
              width="35px"
              alt="No "
            />
          ) : (
            <img
              src={`${global.img_url}/files/no_images.png`}
              width="35px"
              alt="No "
            />
          )}
        </div>
      ),
    },
    {
      title: lan?.action,
      field: "patient",
      render: (row) => (
        <div>
          <Link to={`/edit-brand/${row.id}`} className="btn btn-sm action-btn">
            <i className="far fa-edit"></i>
          </Link>
          &nbsp;
          <button
            onClick={(e) => deleteCountry(e, row.id)}
            className="btn btn-sm action-btn"
          >
            {" "}
            <i className="far fa-trash"></i>{" "}
          </button>
        </div>
      ),
      cellStyle: {
        textAlign: "center",
      },
    },
  ];

  return (
    <div className="page-content">
      <div className="custom-card patients-head ">
        <h5 className="fw-normal custom_py-3 px-2  text-start mb-2 card-title">
          {" "}
          {lan?.pageTitle}
          <Link className="btn btn-sm btn-primary float-end" to="/add-brand">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="16"
              height="16"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
              className="feather feather-plus mb-1"
            >
              <line x1="12" y1="5" x2="12" y2="19"></line>
              <line x1="5" y1="12" x2="19" y2="12"></line>
            </svg>
            {lan?.addManufacturer}
          </Link>
        </h5>
      </div>
      <div className="row">
        <div className="col-md-12 grid-margin">
          <div>
            <div>
              <MaterialTableFixed
                columns={columns}
                data={countrylist}
                options={{
                  search: true,
                  showTitle: false,
                  searchFieldAlignment: "left",
                  pageSize: 10,
                  emptyRowsWhenPaging: false,
                  pageSizeOptions: [5, 10, 20, 50, 100],
                }}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Brand;
